import type { StylesConfig } from "react-select";

/** Admin-only react-select theme (does not affect portal/common ui-kit defaults). */
export const adminSelectStyles: StylesConfig = {
	container: (provided) => ({
		...provided,
		width: "100%",
	}),
	menu: (provided) => ({
		...provided,
		borderRadius: "5px",
		overflow: "hidden",
		zIndex: 10,
	}),
	// Must sit above ui-kit `.modal` (z-index 10100); otherwise menus open behind the dialog
	// and look empty. Matches NetworkSelect (10200).
	menuPortal: (provided) => ({
		...provided,
		zIndex: 10200,
	}),
	control: (provided) => ({
		...provided,
		borderRadius: "5px",
		cursor: "pointer",
		minHeight: "38px",
	}),
	placeholder: (provided) => ({
		...provided,
		textTransform: "uppercase",
		fontSize: "12px",
		color: "#000937",
		textWrap: "nowrap",
	}),
	option: (provided, state) => ({
		...provided,
		cursor: state.isDisabled ? "not-allowed" : "pointer",
		backgroundColor: state.isDisabled ? provided.backgroundColor : state.isSelected ? "#000937" : provided.backgroundColor,
		color: state.isDisabled ? provided.color : state.isSelected ? "#FFFFFF" : provided.color,
		":hover": {
			backgroundColor: state.isDisabled || state.isSelected ? provided.backgroundColor : "#000937",
			color: state.isDisabled || state.isSelected ? provided.color : "#FFFFFF",
		},
	}),
};

export const adminSelectClassNames = {
	className: "react-select",
	classNamePrefix: "react-select",
};

export const adminSelectBaseProps = {
	...adminSelectClassNames,
	styles: adminSelectStyles,
	menuPortalTarget: typeof document !== "undefined" ? document.body : null,
};
